// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Profile/components/VerificationModal/index.css
// module id = 2474
// module chunks = 0